module.exports = __webpack_public_path__ + "static/media/android.19a2e0ea.jpeg";